// extracted by css-extract-rspack-plugin
export default {"wrapper":"ContentfulBreakoutBanner-module__wrapper__ApybVQa","logoWrapper":"ContentfulBreakoutBanner-module__logoWrapper__ycv3MXk"};